import React from 'react';
import { Link } from 'react-router-dom';

// react-bootstrap
import Image from 'react-bootstrap/Image';

// project-import
import { APP_DEFAULT_PATH } from 'config';

// assets
import LogoHoriz from 'assets/images/logo_chrono_terra_version_horizontal.png';

// ==============================|| COMMON DRAWER HEADER ||============================== //

interface DrawerHeaderProps {
  sidebarTheme: boolean;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = () => {
  return (
    <div className="m-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Link to={APP_DEFAULT_PATH} className="b-brand" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Image
          src={LogoHoriz}
          alt="ChronoTerra"
          style={{ height: 40, maxWidth: '100%', objectFit: 'contain', background: '#fff', padding: '5px 12px', borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,.3)' }}
        />
      </Link>
    </div>
  );
};
